import { CircularProgress, Grid, Paper, Typography } from '@mui/material';
import React from 'react';

export type Message = {
  userId: number;
  userName: string;
  userRole: string;
  text: string;
  timestamp: Date;
  loading: boolean;
};

type Props = {
  key: number;
  message: Message;
  currentUserId: number;
};

const colorsForUsernamesInHex = [
  '#2196F3',
  '#43A047',
  '#FB8C00',
  '#E53935',
  '#8E24AA',
  '#546E7A',
  '#009688',
  '#FBC02D',
  '#D81B60',
  '#6D4C41',
];

const ChatMessage: React.FC<Props> = ({ message, currentUserId }) => {
  const isMine = message.userId === currentUserId;
  const userColor = colorsForUsernamesInHex[message.userId % 10];
  return (
    <Grid container justifyContent={isMine ? 'flex-end' : 'flex-start'}>
      <Grid item xs={7}>
        <Paper
          elevation={3}
          sx={{
            m: 1,
            p: 1.5,
            pt: 1,
            pb: 1,
            backgroundColor: isMine ? '#EDF0FD' : '#FFFFFF',
            borderRadius: 2,
            maxWidth: '100%',
          }}
        >
          <Typography
            style={{
              fontSize: '0.90rem',
              color: userColor,
              fontWeight: 'bold',
            }}
            variant="body1"
          >
            {message.userName} | {message.userRole}
          </Typography>
          <div
            style={{
              display: 'flex',
              alignItems: 'end',
              justifyContent: 'space-between',
              color: 'black',
            }}
          >
            <Typography
              variant="body1"
              style={{
                color: 'black',
                fontWeight: 'normal',
              }}
            >
              {message.text}
            </Typography>
            {message.loading ? (
              <CircularProgress
                style={{
                  height: 12,
                  width: 12,
                  margin: '0px 12px -2px 0px',
                }}
              />
            ) : (
              ''
            )}
            <Typography
              sx={{
                whiteSpace: 'nowrap',
                minWidth: 'fit-content',
                ml: 1,
              }}
            >
              {new Date(message.timestamp).toLocaleTimeString('es-ES', {
                hour: '2-digit',
                minute: '2-digit',
              })}
            </Typography>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ChatMessage;
